import { FormArray, FormGroup } from '@angular/forms';
import { QuestionOption, QuestionType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { IQuestionOptionForm } from './question-form-group.interface';
import { QuestionForm } from './question-form.model';
import { QuestionOptionForm } from './question-option-form.model';

export class QuestionFormHiddenChoice extends QuestionForm {
  constructor() {
    super();
    this.extendFormGroup();
  }

  initHiddenEmpty(index: number): void {
    super.initHiddenEmpty(index);
    this.form.get('type').setValue(QuestionType.HiddenChoice);
    (this.form.get('options') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm().form);
  }

  init(question: Question): void {
    super.init(question);
    this.form.get('type').setValue(QuestionType.HiddenChoice);
    this.patchOptions(question.options);
  }

  private extendFormGroup(): void {
    this.form.addControl('options', new FormArray<FormGroup<IQuestionOptionForm>>([]));
  }

  private patchOptions(options: QuestionOption[]): void {
    if (!options || options.length === 0) {
      (this.form.get('options') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm().form);
      return;
    }
    options.forEach((option) => {
      (this.form.get('options') as FormArray<FormGroup<IQuestionOptionForm>>).push(new QuestionOptionForm(option).form);
    });
  }
}
